export {
  cloneError,
  cloneObject,
  isDefined,
  isError,
  isErrorLike,
  isInIframe,
  isNull,
  isNullOrUndefined,
  isRunningTests,
  isUndefined,
};

function cloneError(error: any) {
  /**
   * JSON.stringify-ing an Error object doesn't work as many of its properties are
   * not enumerable, so this method explicitly stringifies the relevant keys
   */
  if (isNullOrUndefined(error)) {
    return error;
  }
  try {
    return JSON.parse(JSON.stringify(error, Object.getOwnPropertyNames(error)));
  } catch {
    return error;
  }
}

function cloneObject(obj: any) {
  return JSON.parse(JSON.stringify(obj));
}

function isInIframe() {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
}

function isDefined(value: any) {
  return !isUndefined(value);
}

function isError(error: any) {
  switch ({}.toString.call(error)) {
    case '[object Error]':
      return true;
    case '[object Exception]':
      return true;
    case '[object DOMException]':
      return true;
    default:
      return error instanceof Error;
  }
}

function isErrorLike(error: any) {
  return (
    !isError(error) &&
    typeof error === 'object' &&
    isDefined(error) &&
    isDefined(error.message)
  );
}

function isNull(value: any) {
  return value === null;
}

function isNullOrUndefined(value: any) {
  return isNull(value) || isUndefined(value);
}

function isRunningTests() {
  return process.env.NODE_ENV === 'test';
}

function isUndefined(value: any) {
  return value === undefined || typeof value === 'undefined';
}
